import { z } from 'zod'

const password = z
  .string()
  .min(8, 'Не меньше 8 символов')
  .max(128, 'Слишком длинный пароль')
  .refine((v) => v.trim() === v, 'Пароль не должен начинаться или заканчиваться пробелом')
  .refine(
    (v) => !/^\d+$/.test(v) && !/^[^\d]+$/.test(v),
    'Нужны и буквы, и цифры',
  )

export const loginSchema = z.object({
  email: z.string().min(1, 'Укажите email').email('Проверьте адрес'),
  password: z.string().min(1, 'Введите пароль'),
})

export const registerSchema = z.object({
  email: z.string().min(1, 'Укажите email').email('Проверьте адрес'),
  password,
  first_name: z.string().trim().min(1, 'Укажите имя').max(80, 'Слишком длинное имя'),
  last_name: z.string().trim().max(80, 'Слишком длинная фамилия'),
  role: z.enum(['student', 'teacher']),
  // Числовое поле ввода отдаёт строку, а пустое значение — пустую строку.
  // Поэтому валидируем строку, а к числу приводим при отправке.
  grade: z
    .string()
    .trim()
    .refine(
      (v) => v === '' || (/^\d{1,2}$/.test(v) && Number(v) >= 1 && Number(v) <= 11),
      'Класс от 1 до 11',
    ),
})

export type LoginForm = z.infer<typeof loginSchema>
export type RegisterForm = z.infer<typeof registerSchema>
